const { VUE_APP_FEATURE_REDACTION, VUE_APP_FEATURE_SIMULATED } = process.env;

export const FEATURES = {
  Redaction: VUE_APP_FEATURE_REDACTION,
  Simulated: VUE_APP_FEATURE_SIMULATED
};
